import { PORTAL_UI_V2 } from "../config/uiTheme";
import CheckListLegacy from "./CheckListLegacy";
import CheckListV2 from "./CheckListV2";

const CheckList = (props) => (PORTAL_UI_V2 ? <CheckListV2 {...props} /> : <CheckListLegacy {...props} />);

export default CheckList;
